'use strict';

import _ from 'underscore';
import mediator from '../../js/mediator';
import config from '../../js/config';
import Analytics from '../Analytics/Analytics';
import Cart from '../Cart/Cart';
import {globalErrorHandler} from '../../utilities/errorHandling';
import ProductSingleBuyingOptionsQuantityFormModal from '../ProductQuantityFormModal/ProductSingleBuyingOptionsQuantityFormModal';
import formTemplate from './templates/BackorderForm-modal.hbs';
import successTemplate from './templates/BackorderForm-modal-success.hbs';

let instance = null;

// Version fo the BackorderForm that supports single buying options
export default class BackorderSingleBuyingOptionsForm extends ProductSingleBuyingOptionsQuantityFormModal {
  initialize() {
    super.initialize({ template: formTemplate });
    this.basicQuantityValidation = false;
  }

  generateValidatedBuyingOption(quantity, sourcePartId, sourceCode) {
    return {
      quantity,
      sourcePartId,
      sourceCode,
      partNumber: this.modalData.partNumber,
      manufacturer: this.modalData.manufacturer,
      type: this.modalData.buyingOption.get('type')
    };
  }

  /**
   * Success action of the submitted form
   *
   * @param {string} firstName
   * @param {string} lastName
   * @param {string} emailAddress
   * @param {Object[]} products
   * @param {string} products[].sourceCode
   * @param {string} products[].sourcePartId
   * @param {number} products[].quantity
   * @param {string} products[].partNumber
   * @param {string} products[].manufacturer
   */
  onSuccess(firstName, lastName, emailAddress, products) {
    Analytics.push(
      config.analytics.events.formSubmission,
      config.analytics.categories.backorder,
      config.analytics.actions.submit,
      this.modalData.partId
    );

    if (products[0].partNumber !== this.modalData.model.attributes.productDetails.partSeo) {
      products[0].partNumber = this.modalData.model.attributes.productDetails.partSeo;
    }

    let salesForceInfo = {
      lowestPrice: this.modalData.buyingOption.get('lowestPrice'),
      highestPrice: this.modalData.buyingOption.get('highestPrice'),
      daysUntilDispatch: this.modalData.buyingOption.get('daysUntilDispatch'),
      shipsFromCountryName: this.modalData.buyingOption.get('shipsFromCountryName'),
      manufacturerLeadTime: this.modalData.buyingOption.get('manufacturerLeadTime'),
      orderIncrement: this.modalData.buyingOption.get('orderIncrement'),
      orderMinimumQuantity: this.modalData.buyingOption.get('orderMinimumQuantity')
    };

    Cart.backorder(firstName, lastName, emailAddress, products[0], this.modalData.model.attributes.productDetails, this.modalData.buyingOption.get('inventoryRegion'), salesForceInfo)
      .then(this.showSuccess.bind(this))
      .catch(this.showError.bind(this));

    this.$('[data-remodal-action="confirm"]').addClass(config.classes.loadingClass);

  }

  showSuccess() {
    this.$el.html(successTemplate());
  }

  showError(error) {
    globalErrorHandler(error);
  }

  /**
   * Get the singleton instance of the backorder modal.
   *
   * @returns {BackorderSingleBuyingOptionsForm}
   */
  static getInstance() {
    if (!instance) {
      instance = new BackorderSingleBuyingOptionsForm();
    }

    return instance;
  }
}

/**
 * Listen for the show modal event.
 *
 * Will only ever run the function once so that multiple listeners will not be added.
 * Creates the modal on demand, but only one instance will ever be made.
 *
 * @listens config.events.cart.showSingleBuyingOptionsBackorderForm
 */
export const createBackorderSingleBuyingOptionsForm = _.once(() => {
  mediator.on(config.events.cart.showSingleBuyingOptionsBackorderForm, data => {
    BackorderSingleBuyingOptionsForm.getInstance().open(data)
  });
});



// WEBPACK FOOTER //
// ./assets/components/BackorderForm/BackorderSingleBuyingOptionsForm.js